// Sentry
import sentry from './modules/sentry.js'
sentry()

// Dependencies
import { _ } from './utils.js'
import chart from './modules/chart.js'
import websiteAgreement from './modules/website-agreement.js'
import { trackReadingRoom } from './utils/tracking.js'
const modulesOnLoad = {
    'dialog': _('open-dialog').nodes(),
    'form-post': _('form-post').nodes(),
    'form-validate': _('', 'validate').nodes(),
    'listing': _('listing').nodes(),
    'nav': _('nav').nodes(),
    'password-validation': _('password-validation').nodes(),
    'responsive-tables': _('.wysiwyg table').nodes(),
    'slider': _('slider').nodes(),
    'tabs': _('tab-trigger').nodes(),
    'toggle-class': _('toggle-class').nodes(),
    'tooltip': _('tooltip', 'element').nodes(),
    'video': _('video', 'element').nodes(),
    'zoom-image': _('zoom-image').nodes(),
    'download-file-tracking': _('download-file-tracking').nodes(),
}

const modulesOnClick = {
    'password-reveal': _('password-trigger', 'element').nodes(),
}

for (const [fileName, nodes] of Object.entries(modulesOnLoad)) {
    if (nodes.length) {
        import(`./modules/${fileName}.js`)
            .then((module) => {
                nodes.forEach((el) => {
                    module.default(el)
                })
            })
            .catch((error) => {
                console.error(fileName, error)
            })
    }
}

for (const [fileName, nodes] of Object.entries(modulesOnClick)) {
    nodes.forEach((el) => {
        el.addEventListener('click', () => {
            import(`./modules/${fileName}.js`)
                .then((module) => {
                    module.default(el)
                })
                .catch((error) => {
                    console.error(fileName, error)
                })
        })
    })
}

chart()
websiteAgreement()
trackReadingRoom()
